import { getEnvironmentVariables } from '../appconfig';
import {
  articleDetailFetcher,
  getLatestContentUrl,
} from '../datafetchers/ArticlePage';
import { storeDataFetcher } from '../datafetchers/Store';
import { getContentLanguage } from './ContentUtils';
import {
  getEncodedUrl,
  getFilteredCategoryContent,
  getScreenName,
} from './helper';

import { fireEvent } from './fireEvent';

export const getPostUpdatedDate = (created_at) => {
  const current_date = new Date();
  const difference_date = current_date - new Date(created_at);
  // convert to years
  let difference_dates = difference_date / 31104000000;

  let conversions = [
    { mul: 1, text: 'year' },
    { mul: 12, text: 'month' },
    { mul: 30, text: 'day' },
    { mul: 24, text: 'hour' },
    { mul: 60, text: 'minute' },
  ];

  for (let i = 0; i < conversions.length; i++) {
    difference_dates = difference_dates * conversions[i].mul;
    const convert_int = parseInt(difference_dates);
    if (convert_int) {
      const text =
        convert_int > 1 ? conversions[i].text + 's' : conversions[i].text;
      return `${parseInt(difference_dates)} ${text} ago`;
    }
  }
};

export const getInsideParanthesisText = (pregnancy_week) => {
  const startIndex = pregnancy_week?.indexOf('(');
  const endIndex = pregnancy_week?.indexOf(')');
  return pregnancy_week?.slice(startIndex + 1, endIndex);
};

export function getAcceptedSuggestedAnswers(commentsData) {
  if (commentsData?.length > 0) {
    let acceptedAnswer = {};
    const firstAnswer = commentsData?.[0];
    if (commentsData?.[0].state == 'accepted') {
      acceptedAnswer = {
        text: firstAnswer?.message,
        dateCreated: firstAnswer?.created_at,
        upvoteCount: firstAnswer?.comment_like_length,
      };
    }

    const suggestedAnswer = [];
    for (let comments of commentsData) {
      if (comments.state === 'suggested') {
        suggestedAnswer.push({
          text: comments?.message,
          dateCreated: comments?.created_at,
          upvoteCount: comments?.comment_like_length,
          // author: {
          //     name: "SomeUser",
          // },
        });
      }
    }
    return {
      acceptedAnswer,
      suggestedAnswer: suggestedAnswer?.slice(0, 5),
    };
  }
}

export function getTagData(postData) {
  const tagsWithId = postData?.content?.tagsWithId;
  const primary_tag_id = postData?.primary_tag_id;
  if (tagsWithId)
    for (const element of tagsWithId) {
      if (element?.term_id == primary_tag_id) {
        return element;
      }
    }
  return tagsWithId?.[0];
}

export const trimmedToLength = (message, length) => {
  if (message?.length > 47) return message?.slice(0, length) + '.';
  else return message;
};

// Instrumentation

export const clicked_cta_event = (
  section_name,
  cta,
  parent,
  deeplink_value,
  shape,
  content_id,
  object_id,
) => {
  fireEvent({
    category: 'clicked_cta',
    screen_name: getScreenName(),
    section_name: section_name,
    deeplink_value: deeplink_value,
    shape: shape,
    cta: cta,
    parent: parent,
    page_url: window.location.href,
    content_id,
    object_id,
  });
};

export const clicked_helpful_count = (
  section_name,
  deeplink_value,
  id,
  question_id,
) => {
  fireEvent({
    category: 'clicked_article_helpful_yes',
    screen_name: getScreenName(),
    section_name: section_name,
    deeplink_value: deeplink_value,
    content_id: id,
    parent: question_id,
    page_url: window.location.href,
  });
};

export const getMetaDescription = (content, primaryCategory) => {
  const pregnancy_week = content?.post?.content?.propertytags?.weekPreg;
  const insideText = getInsideParanthesisText(pregnancy_week);
  const comments_length = content?.comments?.length;

  return `Wondering about ${primaryCategory?.toLowerCase()}? Here's what a person ${insideText}. Click here to see what 10 lakh+ young parents have to say | MyloFamily`;
};

export const filterQuestionData = (questionData) => {
  questionData.comments = filterComments(questionData.comments);
  questionData.post = filterPostData(questionData.post);
  questionData.similarTopics = filterRelatedTopics(questionData?.similarTopics);
  return questionData;
};

const filterComments = (comments) => {
  return comments.map((data) => {
    return {
      id: data?.id || null,
      message: data?.message || null,
      created_at: data?.created_at || null,
      comment_like_length: data?.comment_like?.length || null,
      user_details: filterUserDetails(data?.user_details),
      propertytags: data?.propertytags || {},
      state: data?.state,
    };
  });
};

const filterUserDetails = (user_details) => {
  return {
    stage: user_details?.stage || null,
    followers: user_details?.followers || null,
  };
};
const filterPostData = (data) => {
  return {
    contentType: data?.contentType || null,
    content_type: data?.content_type || null,
    id: data?.id || null,
    object_id: data?.object_id || null,
    primary_tag_id: data?.primary_tag_id || null,
    content: filterContentData(data?.content),
  };
};

const filterContentData = (data) => {
  return {
    id: data?.id || null,
    message: data?.message || null,
    created_at: data?.created_at || null,
    updated_at: data?.updated_at || null,
    web_url: data?.web_url || null,
    webpImages: data?.webpImages || null,
    user_details: {
      stage: data?.user_details?.stage || null,
      followers: data?.user_details?.followers || null,
      webpImages: data?.user_details?.webpImages || null,
      thumbImages: data?.user_details?.thumbImages || null,
    },
    message: data?.message || null,
    tags: data?.tags || null,
    tagsWithId: filterTagsWithId(data?.tagsWithId),
    propertytags: data?.propertytags,
    comments: data?.comments,
    breadcrumbs: data?.breadcrumbs,
    meta_description: data?.meta_description,
    newFiles: data?.newFiles || {},
    feature_endorsed_doctor: {
      image: data?.feature_endorsed_doctor?.image || null,
    },
  };
};

const filterTagsWithId = (tags) => {
  return tags.map((tag) => {
    return {
      term_id: tag?.term_id || null,
      description: tag?.description || null,
      contentCount: tag?.contentCount || null,
      image: tag?.image || null,
    };
  });
};

const filterRelatedTopics = (data) => {
  if (data?.items) {
    return {
      items: filterItems(data?.items),
    };
  }
  return {};
};

const filterItems = (items) => {
  return items.map((item) => {
    const keys = ['description', 'term_id', 'id', 'webUrl', 'web_url', 'title'];
    const data = {};

    for (let key of keys) {
      data[key] = item[key] || null;
    }
    return data;
  });
};
export const getQuestionData = async (context, caller) => {
  const webUrl = context.params.questionId;
  let id = webUrl;
  if (webUrl?.includes('-')) {
    const url = context.params.questionId.split('-');
    id = url.pop();
  }
  const data = await getLatestContentUrl('question', id);
  const urlRecognised = data?.data?.web_url;
  let complete_web_url = '/question/' + webUrl;
  if (context.locale != 'en')
    complete_web_url = '/' + context.locale + complete_web_url;

  if (urlRecognised) {
    if (complete_web_url == urlRecognised) {
      const result = checkIfWeWantDataOnBasisEnv(
        caller,
        webUrl,
        context.locale,
        id,
      );
      if (result) {
        return result;
      }
      try {
        let questionData = await articleDetailFetcher('post', id, true);
        questionData.data = filterQuestionData(questionData?.data);
        const selectedLanguage = getContentLanguage(questionData);
        let data = await storeDataFetcher({
          skip: 0,
          limit: 10,
          lang: 'en',
          inApp: false,
          desktopView: true,
          key: 'store',
        });
        return {
          props: {
            questionData: questionData,
            questionId: id,
            id: webUrl,
            webUrl: context.params.questionId,
            language: selectedLanguage,
            categoryData: getFilteredCategoryContent(data?.data?.categories),
          },
        };
      } catch (error) {
        if (error?.response?.status == '404') {
          return {
            notFound: true,
          };
        } else {
          return {
            redirect: {
              destination: '/500',
            },
          };
        }
      }
    } else {
      const final_url = getEncodedUrl(urlRecognised);
      return {
        redirect: {
          destination: final_url,
          statusCode: 301,
        },
      };
    }
  }
  return {
    notFound: true,
  };
};

export const checkIfWeWantDataOnBasisEnv = (caller, webUrl, locale, id) => {
  const isServerAndNotProductionEnv =
    caller === 'server' && getEnvironmentVariables() !== 'production';
  const isClientAndProducttionEnv =
    caller === 'client' && getEnvironmentVariables() === 'production';
  if (isServerAndNotProductionEnv || isClientAndProducttionEnv) {
    return {
      props: {
        questionId: id,
        locale: locale,
        id: webUrl,
      },
    };
  }
};
